import type { WallFloorDefInput } from '../schemas/items';

/** Wallpapers & floors (docs/design/content-items.md §E). Bought once, usable in every room. */
export const WALL_FLOORS = [
  // Studio NANO defaults: owned as soon as the studio opens (studio.ts), also sold for other rooms.
  {
    id: 'wall_studio_paper',
    kind: 'wall',
    nameKey: 'wallfloor.wall_studio_paper.name',
    price: 60,
    unlockId: 'unl_studio',
    isDefault: false,
    texture: 'tile_wall_studio_paper',
    themeTags: ['cozy'],
  },
  {
    id: 'floor_studio_parquet',
    kind: 'floor',
    nameKey: 'wallfloor.floor_studio_parquet.name',
    price: 60,
    unlockId: 'unl_studio',
    isDefault: false,
    texture: 'tile_floor_studio_parquet',
    themeTags: ['cozy'],
  },
  {
    id: 'wall_tea_jade',
    kind: 'wall',
    nameKey: 'wallfloor.wall_tea_jade.name',
    price: 80,
    unlockId: 'unl_minimart',
    storyGate: { storyId: 'lam', stage: 2 },
    isDefault: false,
    texture: 'tile_wall_tea_jade',
    themeTags: ['cozy'],
  },
  {
    id: 'floor_tea_wood',
    kind: 'floor',
    nameKey: 'wallfloor.floor_tea_wood.name',
    price: 80,
    unlockId: 'unl_minimart',
    storyGate: { storyId: 'lam', stage: 2 },
    isDefault: false,
    texture: 'tile_floor_tea_wood',
    themeTags: ['cozy'],
  },
  {
    id: 'wall_europe_stone',
    kind: 'wall',
    nameKey: 'wallfloor.wall_europe_stone.name',
    price: 80,
    unlockId: 'unl_minimart',
    storyGate: { storyId: 'elias', stage: 2 },
    isDefault: false,
    texture: 'tile_wall_europe_stone',
    themeTags: ['cozy'],
  },
  {
    id: 'floor_europe_oak',
    kind: 'floor',
    nameKey: 'wallfloor.floor_europe_oak.name',
    price: 80,
    unlockId: 'unl_minimart',
    storyGate: { storyId: 'elias', stage: 2 },
    isDefault: false,
    texture: 'tile_floor_europe_oak',
    themeTags: ['cozy'],
  },
  {
    id: 'wall_cream',
    kind: 'wall',
    nameKey: 'wallfloor.wall_cream.name',
    isDefault: true,
    texture: 'tile_wall_cream',
    themeTags: ['cozy'],
  },
  {
    id: 'wall_pink_stripe',
    kind: 'wall',
    nameKey: 'wallfloor.wall_pink_stripe.name',
    price: 80,
    unlockId: 'unl_palette_2',
    isDefault: false,
    texture: 'tile_wall_pink_stripe',
    themeTags: ['cute', 'sweet'],
  },
  {
    id: 'wall_mint_dots',
    kind: 'wall',
    nameKey: 'wallfloor.wall_mint_dots.name',
    price: 80,
    unlockId: 'unl_palette_2',
    isDefault: false,
    texture: 'tile_wall_mint_dots',
    themeTags: ['cute'],
  },
  {
    id: 'wall_lavender_check',
    kind: 'wall',
    nameKey: 'wallfloor.wall_lavender_check.name',
    price: 80,
    unlockId: 'unl_palette_2',
    isDefault: false,
    texture: 'tile_wall_lavender_check',
    themeTags: ['cozy'],
  },
  {
    id: 'floor_wood',
    kind: 'floor',
    nameKey: 'wallfloor.floor_wood.name',
    isDefault: true,
    texture: 'tile_floor_wood',
    themeTags: ['cozy'],
  },
  {
    id: 'floor_pink_tile',
    kind: 'floor',
    nameKey: 'wallfloor.floor_pink_tile.name',
    price: 80,
    unlockId: 'unl_palette_2',
    isDefault: false,
    texture: 'tile_floor_pink_tile',
    themeTags: ['cute', 'sweet'],
  },
  {
    id: 'floor_mint_checker',
    kind: 'floor',
    nameKey: 'wallfloor.floor_mint_checker.name',
    price: 80,
    unlockId: 'unl_palette_2',
    isDefault: false,
    texture: 'tile_floor_mint_checker',
    themeTags: ['cute'],
  },
] as const satisfies readonly WallFloorDefInput[];
